import * as Lodash from 'lodash'
import * as LodashFP from 'lodash/fp'

import { IStringAnyMap } from '../types/map'

export const init = (DI: any): IStringAnyMap => {
  const getState = () => DI.get('store').getState()
  const assigns = {
    Lodash,
    LodashFP,
    getState,
  }

  return assigns
}
